import { Box, Typography } from '@mui/material';
import styled from 'styled-components';
import Grid from 'components/core/Grid';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import { CheckoutBoxWrapper } from '../../styles';

export const StyledGrid = styled(Grid)`
display: flex;
flex-direction: column;
`;

export const CancellationPolicyItemWrapper = styled(Box)`
display: flex;
flex-direction: column;

& > div:not(:first-child) div {
  border-top: 2px solid #fff;
}

& > div:first-child div {  
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}

& > div:nth-last-child(2) div {  
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
`;

export const StyledBox = styled(Box)`
  width: ${props => props.theme.spacing(4)};
  min-width: ${props => props.theme.spacing(4)};
  height: 100%;
  margin-right: ${props => props.theme.spacing(2)};
  background-color: #ccc;

  &.fullrefund {
    background-color: ${props => props.theme.palette.success.main};
  }

  &.partialrefund {
    background-color: ${props => props.theme.palette.warning.main};
  }

  &.norefund {
    background-color: ${props => props.theme.palette.error.main};
  }

  &.fees {
    display: none;    
  }
`;

export const StyledCancellationPolicyItem = styled(Box)`
  display: flex;
  align-items: center; 
  flex: 1; 

  &:last-child {
    border-top: 1px dashed ${props => props.theme.palette.grey[300]};
    margin-top: ${props => props.theme.spacing(2)};
  }  
  
`;

export const StyledTypography = styled(Typography)`
  padding: ${props => props.theme.spacing(1)} 0;
`;


const CancellationPolicyItem = ({ label, value, type, isLoading }: any) => {
  return (
    <LoadingSkeleton isLoading={isLoading} >
      <StyledCancellationPolicyItem>
        <StyledBox className={type}></StyledBox>
        <StyledTypography variant="body1">
          {label} <strong>{value}</strong>
        </StyledTypography>
      </StyledCancellationPolicyItem>
    </LoadingSkeleton>
  );
};

interface Props {
  checkoutData: BookingCheckoutResponse | undefined;
  title?: string;
}

export const CheckoutCancellationPolicy = ({
  checkoutData,
  title = 'Cancellation Policy',
}: Props) => {
  const isLoading = !checkoutData;

  const cancellationPoints = checkoutData?.BOOKING.PROPERTY.CANCELLATION_POLICY.POINTS ?? [];

  return (
    <>
      <Grid item xs={12}>
        <AppDivider marginVertical={'16px'} borderWidth='0' />
      </Grid>
      <CheckoutBoxWrapper>
        <StyledGrid item xs={12}>
          <CheckoutSectionTitle>{title}</CheckoutSectionTitle>
          <CancellationPolicyItemWrapper>
            {cancellationPoints.map(point => {
              return <CancellationPolicyItem key={point.LABEL} label={point.LABEL} type={point.TYPE} value={''} isLoading={isLoading} />;
            })}
          </CancellationPolicyItemWrapper>
        </StyledGrid>
      </CheckoutBoxWrapper>
    </>

  );
};
